import { Action, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormContainer } from '../../fxfs/schema/form.schema';
import { startSessionSuccess } from '../actions/session.actions';
import { SessionFormState, SessionState } from '../../types/session';
import { JWK } from 'jose';
import { RootState } from '../store';
import { changeSessionState } from './session.slice';

type FormState = {
	init: true;
	id: string;
	schema: FormContainer;
	encryptionKey: JWK;
	context?: string;
};

type State = FormState | { init: false };

const initialState = { init: false } as State;

export const formSlice = createSlice({
	name: 'session/form',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(isSessionStateChange, (formState, action) => {
			const state = action.payload;
			if (!isFormState(state)) return formState;

			const data = state.result;
			return {
				init: true,
				id: data.form.form_identifier,
				context: data.context,
				encryptionKey: data.key,
				schema: data.form
			};
		});
	}
});

const isSessionStateChange = (action: Action): action is PayloadAction<SessionState> => {
	return action.type === startSessionSuccess.type || action.type === changeSessionState.type;
};

const isFormState = (state: SessionState): state is SessionFormState => {
	return state.status === 'CONSUMER_INPUT_NEEDED' && state.result.type === 'form';
};

// SELECTORS

export const selectFormSchema = (state: RootState) => {
	const form = state.form;
	if (!form.init) return undefined;
	return form.schema;
};

export const selectFormContext = (state: RootState) => {
	const form = state.form;
	if (!form.init) return undefined;
	return form.context;
};

export const selectFormEncryptionKey = (state: RootState) => {
	const form = state.form;
	if (!form.init) return undefined;
	return form.encryptionKey;
};
